export const FETCH_GTV_REQUEST = 'FETCH_GTV_REQUEST';
export const FETCH_GTV_DATA = 'FETCH_GTV_DATA';
export const FETCH_GTV_ERROR = 'FETCH_GTV_ERROR';
export const RESET_GTV_DATA = 'RESET_GTV_DATA';
